export default __webpack_public_path__ + "bac5a6386eb27e1a5ca0b01202959dd5.svg";